import type {GatsbyBrowser} from 'gatsby'
import {init} from '@plausible-analytics/tracker'

// Self-hosted DM Mono (weights used across the site: 300/400/500). Bundled at
// build time so the font is referenced from the initial CSS instead of a
// late JS-injected Google Fonts stylesheet — see gatsby-config.ts.
import '@fontsource/dm-mono/300.css'
import '@fontsource/dm-mono/400.css'
import '@fontsource/dm-mono/500.css'
import './src/styles/global.scss'

// Plausible Analytics — privacy-friendly, cookieless. Initialised here rather than
// in gatsby-ssr because the tracker is browser-only (it relies on browser APIs and
// patches the History API to auto-capture Gatsby's client-side route changes).
// captureOnLocalhost defaults to false, so dev/preview traffic is ignored.
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  init({domain: 'micepapai.com'})
}
